import React from 'react'

import { AdminContext } from 'contexts/AdminContext'
import { ZariContext } from '_zari/context'

import { Table, Col, Row } from '_zari/core'

import * as ProductosCrud from 'services/producto.service'

import FilaBusquedaTemplate from './filasTemplates/filaBusqueda'
import FilaDetalleTemplate from './filasTemplates/filaDetalle'
import CeldaCodigoBarra from './filasTemplates/celdaCodigoBarra'

const DetallesSection = ({
  detalles,
  dispatch,
  tipoProducto,
  incluyeIGV,
  idSocio,
  reiniciarFormularioMontos,
  flagEditarComentarios,
  idListaPrecio
}) => {
  const __adminContext = React.useContext(AdminContext)
  const __zariContext = React.useContext(ZariContext)

  const rowHeaders = React.useMemo(() => {
    return [
      { label: '#', width: 40 },
      { label: 'COD', width: 95 },
      { label: 'DESCRIPCIÓN' },
      { label: 'CANT', width: 65 },
      { label: 'UNIDAD' },
      { label: 'PRECIO', width: 130 },
      { label: 'TOTAL' },
      { label: '', width: 25 }
    ]
  }, [])

  const prefijoIdFila = React.useRef(1)

  const seleccionarProductoViaBusquedaHandler = React.useCallback(
    productoSeleccionado => {
      ProductosCrud.getProducto_Ventas(productoSeleccionado.value, idListaPrecio).then(({ data }) => {
        if (data.flagAnticipo) {
          const existeDetalleValido = detalles.some(x => !x.esFilaBusqueda)
          if (existeDetalleValido) {
            __zariContext.snack('error', 'El anticipo solo puede ser ingresado como detalle único.')
            return
          }
        }

        reiniciarFormularioMontos()
        prefijoIdFila.current = prefijoIdFila.current + 1

        let precioListaPrincipal = data.precios.map(x => {
          return {
            _idProductoPresentacionPrecio: x._id,
            precio: x.precio
          }
        })[0]

        if (data.precios) {
          data.precios = data.precios.map(val => {
            return {
              _id: val._id,
              precio: val.precio,
              precioListaNombre: val.precioListaNombre,
              precioListaPrincipal: val.precioListaPrincipal
            }
          })
        }

        const { _id: _idProductoPresentacion, ...newData } = data

        dispatch({
          type: 'agregar',
          payload: {
            incluyeIGV,
            nuevaFila: false,
            viaCodBar: false,
            flagCodigoBarra: false,
            _idProductoPresentacion,
            ...precioListaPrincipal,
            ...newData
          }
        })

        var objDiv = document.getElementById('venta-container-tabladetalles')
        objDiv.scrollTop = objDiv.scrollHeight
      })
    },
    [__zariContext, dispatch, incluyeIGV, detalles, idListaPrecio, reiniciarFormularioMontos]
  )

  const seleccionarProductoViaCodigoBarraHandler = React.useCallback(
    codigoBarraSeleccionado => {
      ProductosCrud.getProducto_Ventas_CodigoBarras(codigoBarraSeleccionado, idListaPrecio)
        .then(({ data }) => {
          if (data.flagAnticipo) {
            const existeDetalleValido = detalles.some(x => !x.esFilaBusqueda)
            if (existeDetalleValido) {
              __zariContext.snack('error', 'El anticipo solo puede ser ingresado como detalle único.')
              return
            }
          }

          prefijoIdFila.current = prefijoIdFila.current + 1

          let precioListaPrincipal = data.precios.map(x => {
            return {
              _idProductoPresentacionPrecio: x._id,
              precio: x.precio
            }
          })[0]

          if (data.precios) {
            data.precios = data.precios.map(val => {
              return {
                _id: val._id,
                precio: val.precio,
                precioListaNombre: val.precioListaNombre,
                precioListaPrincipal: val.precioListaPrincipal
              }
            })
          }

          const { _id: _idProductoPresentacion, ...newData } = data

          dispatch({
            type: 'agregar',
            payload: {
              incluyeIGV,
              nuevaFila: false,
              viaCodBar: false,
              flagCodigoBarra: true,
              _idProductoPresentacion,
              ...precioListaPrincipal,
              ...newData
            }
          })

          reiniciarFormularioMontos()

          var objDiv = document.getElementById('venta-container-tabladetalles')
          objDiv.scrollTop = objDiv.scrollHeight
        })
        .catch(() => {
          __zariContext.toast('error', 'No existe el codigo de barra ingresado.')
        })
    },
    [__zariContext, dispatch, incluyeIGV, reiniciarFormularioMontos, detalles, idListaPrecio]
  )

  const actualizarFilaHandler = React.useCallback(
    data => {
      const { saltarCampo, ...newData } = data
      if (saltarCampo) {
        prefijoIdFila.current = prefijoIdFila.current + 1
      }
      dispatch({ type: 'actualizar', payload: { incluyeIGV, ...newData } })
      reiniciarFormularioMontos()
    },
    [dispatch, reiniciarFormularioMontos, incluyeIGV]
  )

  const actualizarComentarioHandler = React.useCallback(
    ({ _idFila, comentario }) => {
      dispatch({
        type: 'actualizarComentario',
        payload: { _idFila, comentario }
      })
    },
    [dispatch]
  )

  const eliminarFilaHandler = React.useCallback(
    _idFila => {
      prefijoIdFila.current = prefijoIdFila.current + 1
      dispatch({ type: 'eliminar', payload: { _idFila } })
      reiniciarFormularioMontos(true)
    },
    [dispatch, reiniciarFormularioMontos]
  )

  const rowTemplate = React.useCallback(
    (row, key) => {
      if (row.esFilaBusqueda) {
        return <React.Fragment key={key} />
      } else {
        return (
          <FilaDetalleTemplate
            index={key}
            key={`${prefijoIdFila.current}${key}filaDetalle`}
            row={row}
            idSocio={idSocio}
            actualizarFilaHandler={actualizarFilaHandler}
            actualizarComentarioHandler={actualizarComentarioHandler}
            eliminarFilaHandler={eliminarFilaHandler}
            flagEditarComentarios={flagEditarComentarios}
          />
        )
      }
    },
    [actualizarFilaHandler, actualizarComentarioHandler, eliminarFilaHandler, flagEditarComentarios, idSocio]
  )

  const filaBusquedaInfo = React.useMemo(() => {
    return detalles.find(x => x.esFilaBusqueda)
  }, [detalles])

  return (
    <>
      <Row className='mt-2 mb-1'>
        <Col md={12}>
          <Table
            containerId='venta-container-tabladetalles'
            tablaDetalle
            filas={detalles}
            headRows={rowHeaders}
            rowTemplate={rowTemplate}
          />
        </Col>
      </Row>
      {filaBusquedaInfo && (
        <Row style={{ marginBottom: '3.5rem' }}>
          {__adminContext.valoresConfiguracionCompania.flagCodigoBarra && (
            <Col md={1}>
              <CeldaCodigoBarra
                esFilaActiva={filaBusquedaInfo.__filaActiva}
                seleccionarProductoViaCodigoBarraHandler={seleccionarProductoViaCodigoBarraHandler}
              />
            </Col>
          )}
          <Col md={__adminContext.valoresConfiguracionCompania.flagCodigoBarra ? 11 : 12}>
            <FilaBusquedaTemplate
              key={`${prefijoIdFila.current}filaBusqueda`}
              esFilaActiva={filaBusquedaInfo.__filaActiva}
              tipoProducto={tipoProducto}
              seleccionarProductoViaBusquedaHandler={seleccionarProductoViaBusquedaHandler}
              seleccionarProductoViaCodigoBarraHandler={seleccionarProductoViaCodigoBarraHandler}
            />
          </Col>
        </Row>
      )}
    </>
  )
}

export default React.memo(DetallesSection)
